import { Puzzle } from "components/icons/generated";
import Box from "ds/components/Box";
import Link from "ds/components/Link";

import { VariableCellComponentProps } from "./types";

const SourceCell = ({ context, isAdmin }: VariableCellComponentProps) => {
  if (!context) {
    return null;
  }

  return (
    <Box>
      <Link disabled={!isAdmin} href={`/context/${context.contextId}`} startIcon={Puzzle}>
        {context.contextName}
      </Link>
    </Box>
  );
};

export default SourceCell;
